import {connectToStores} from 'epic-alt-utils';
import LoginActions from 'epic-fortnite-react/actions/LoginActions';
import Error404 from 'epic-fortnite-react/components/error/Error404';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import Helmet from 'react-helmet';

import {VideoRecapStore, LoginStore} from '../../stores';

/**
 * VideoRecap Landing Page View
 */
@connectToStores
class VideoRecapView extends React.Component {
  static propTypes = {
    videoRecapStore: PropTypes.object,
    loginStore: PropTypes.object,
    location: PropTypes.object,
  };

  static getStores() {
    return [VideoRecapStore, LoginStore];
  }

  static getPropsFromStores() {
    return {
      videoRecapStore: VideoRecapStore.getState(),
      loginStore: LoginStore.getState(),
    };
  }

  getReturnPath = () => {
    const {location} = this.props;
    const query = queryString.parse(location.search) || '';
    query.fromCTA = true;
    return `${location.pathname}?${queryString.stringify(query)}`;
  };

  login = () => {
    LoginActions.requestLogin({
      returnPath: this.getReturnPath(),
    });
  };

  render() {
    if (!this.props.videoRecapStore || !this.props.videoRecapStore.cms) return <Error404 />;
    const {
      cms: {
        bgImg,
        title,
        subtitle,
        ctaBtnText,
        loginBtnText,
        metaImage,
        metaDescription,
        metaTitle,
      },
    } = this.props.videoRecapStore;
    const tags = [
      {itemProp: 'name', content: metaTitle},
      {itemProp: 'description', content: metaDescription},
      {itemProp: 'image', content: metaImage},
      {name: 'description', content: metaDescription},
      {name: 'twitter:title', content: metaTitle},
      {name: 'twitter:description', content: metaDescription},
      {name: 'twitter:image', content: metaImage},
      {property: 'og:title', content: metaTitle},
      {property: 'og:image', content: metaImage},
      {property: 'og:description', content: metaDescription},
    ];
    const {isLoggedIn, videoRecapLink} = this.props.loginStore;
    return (
      <div className="videoRecap" style={{backgroundImage: `url(${bgImg})`}}>
        <Helmet meta={tags} />
        <div className="videoRecap-underlayer">
          <h1 className="videoRecap-title" dangerouslySetInnerHTML={{__html: title}} />
          <h4 className="videoRecap-subtitle" dangerouslySetInnerHTML={{__html: subtitle}} />
          {isLoggedIn ? (
            <a
              href={videoRecapLink}
              className="btn btn-primary"
              target="blank"
              dangerouslySetInnerHTML={{__html: ctaBtnText}}
            />
          ) : (
            <button
              onClick={this.login}
              className="btn btn-primary"
              dangerouslySetInnerHTML={{__html: loginBtnText}}
            />
          )}
        </div>
        {/* <LoadScreen show={loading} /> */}
      </div>
    );
  }
}

export default VideoRecapView;
